import React, { useMemo } from 'react';
import { Chart } from 'react-google-charts';
import Loader from '../../common/loader';
import utils from '../../../utils/miscUtils';

const MONTH_LABELS = [
    'Ene',
    'Feb',
    'Mar',
    'Abr',
    'May',
    'Jun',
    'Jul',
    'Ago',
    'Sep',
    'Oct',
    'Nov',
    'Dic',
];

const ColumnOptions = {
    chartArea: { left: '10%', top: '12%', width: '85%', height: '75%' },
    colors: ['#00a4d3'],
    legend: 'none',
    hAxis: { textStyle: { fontSize: 11 } },
    vAxis: { minValue: 0 },
};

const emptyPeriod = { bottles: 0 };

const aggregateByMonth = (daily = []) => {
    const currentMonth = new Date().getMonth() + 1;
    const months = MONTH_LABELS.map((label, index) => ({
        month: index + 1,
        label,
        bottles: 0,
    }));

    daily.forEach((item) => {
        const monthIndex = Number(String(item.date).slice(5, 7)) - 1;
        if (monthIndex >= 0 && monthIndex < 12) {
            months[monthIndex].bottles += Number(item.bottles) || 0;
        }
    });

    return months.filter((item) => item.month <= currentMonth);
};

const StatCard = ({ title, bottles, badge }) => (
    <div className="col-xl-3 col-md-6 col-12">
        <div className="card" style={{ marginBottom: '12px' }}>
            <div className="card-body p-2">
                <p className="mb-2">
                    <span className={`badge badge-${badge}`}>{title}</span>
                </p>
                <h4 className="mb-0">{bottles} botellones</h4>
                <p className="m-0">{utils.currency(bottles * 1.35).trim()} $</p>
            </div>
        </div>
    </div>
);

function UserDeliveryStats({ stats, loading }) {
    const monthly = useMemo(() => aggregateByMonth(stats && stats.daily), [stats]);

    const chartData = useMemo(
        () => [
            ['Mes', 'Botellones'],
            ...monthly.map((item) => [item.label, item.bottles]),
        ],
        [monthly],
    );

    if (loading) {
        return (
            <div className="row" style={{ marginTop: '12px' }}>
                <div className="col-sm-12">
                    <div className="card" style={{ marginBottom: '12px', marginTop: '12px' }}>
                        <div className="card-body" style={{ display: 'flex', minHeight: 80 }}>
                            <Loader />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    if (!stats) {
        return null;
    }

    return (
        <div className="row" style={{ paddingTop: '12px' }}>
            <StatCard
                title="Hoy"
                bottles={(stats.today || emptyPeriod).bottles}
                badge="warning"
            />
            <StatCard
                title="Esta semana"
                bottles={(stats.week || emptyPeriod).bottles}
                badge="info"
            />
            <StatCard
                title="Este mes"
                bottles={(stats.month || emptyPeriod).bottles}
                badge="primary"
            />
            <StatCard
                title="Este año"
                bottles={(stats.year || emptyPeriod).bottles}
                badge="success"
            />
            <div className="col-sm-12">
                <div className="card order-graph sales-carousel" style={{ marginBottom: '12px' }}>
                    <div className="card-header">
                        <h4>Progreso mensual</h4>
                        <div className="small-chartjs">
                            <div className="flot-chart-placeholder" id="user-delivery-monthly-chart">
                                <Chart
                                    height="280px"
                                    width="100%"
                                    chartType="ColumnChart"
                                    loader={<div>Cargando Datos</div>}
                                    data={chartData}
                                    options={ColumnOptions}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UserDeliveryStats;
